import { render } from "./OrbitObjectsTable.vue?vue&type=template&id=0b8c2c60"
import script from "./OrbitObjectsTable.vue?vue&type=script&lang=js"
export * from "./OrbitObjectsTable.vue?vue&type=script&lang=js"

import "./OrbitObjectsTable.vue?vue&type=style&index=0&id=0b8c2c60&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__